import { useCallback, ChangeEvent } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import InputMask from '@mona-health/react-input-mask';
import { sanitizeMaskedInputValue } from '@/utils/formatters';

interface PhoneInputProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const PHONE_NUMBER_LENGTH = 10;

const PhoneInput = ({ value, disabled, onChange, ...props }: PhoneInputProps) => {
  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    e.target.value = sanitizeMaskedInputValue(e.target.value, PHONE_NUMBER_LENGTH);
    onChange(e);
  }, []);
  return (
    <InputMask
      mask='(999) 999 - 9999'
      value={value ?? ''}
      onChange={handleChange}
      disabled={disabled}
    >
      {<TextField variant='outlined' {...props} disabled={disabled} />}
    </InputMask>
  );
};

export default PhoneInput;
